module.exports = __webpack_public_path__ + "img/swiper-class.92371c32.jpg";